module.exports = __webpack_public_path__ + "img/rcgysq_sqtj.4acc0685.png";